/**
 * Что в карточке лекарства участвует в поиске — одно для аптечки и
 * таблетницы.
 *
 * Названия лекарств человек как раз и не помнит. Поэтому в поиск входят
 * действующее вещество («парацетамол» найдёт «Панадол»), назначение («горло»
 * находит группу «Простуда, горло и нос»), форма, место, кто назначил и
 * заметка: слово, которое человек сам туда записал, он и помнит.
 */

import type { Medication } from '@/shared/db/schema';

import { MEDICATION_FORM_META } from './medication-meta';
import { getPurpose } from './purposes';

/**
 * С какого числа лекарств появляется поиск — в аптечке и в таблетнице.
 *
 * Пока лекарств меньше десятка, поиск только отнимает строку экрана: список
 * целиком охватывается взглядом быстрее, чем набирается слово.
 */
export const MEDICATION_SEARCH_FROM = 8;

export function medicationSearchFields(medication: Medication): string[] {
  return [
    medication.name,
    medication.activeIngredient,
    medication.strength,
    MEDICATION_FORM_META[medication.form]?.label ?? '',
    medication.storagePlace,
    getPurpose(medication.purposeKey).title,
    medication.prescribedBy,
    medication.notes,
  ];
}
